import React from 'react'
import { Box } from '@mui/material'
import { SpotlightPosition } from '../../../hooks/tour/useTourSpotlight'

interface TourSpotlightProps {
  isTourActive: boolean
  spotlightPosition: SpotlightPosition
  allowInteraction: boolean
}

const TourSpotlight: React.FC<TourSpotlightProps> = ({
  isTourActive,
  spotlightPosition,
  allowInteraction,
}) => {
  if (!isTourActive) {
    return null
  }

  return (
    <>
      {/* Main backdrop */}
      <Box
        className="tour-custom-backdrop"
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          zIndex: 99999,
          pointerEvents: 'auto',
          userSelect: 'none',
          cursor: 'default',
          ...(spotlightPosition.width > 0 &&
            spotlightPosition.height > 0 && {
              clipPath: `polygon(
              0% 0%, 0% 100%,
              ${spotlightPosition.x}px 100%,
              ${spotlightPosition.x}px ${spotlightPosition.y}px,
              ${spotlightPosition.x + spotlightPosition.width}px ${spotlightPosition.y}px,
              ${spotlightPosition.x + spotlightPosition.width}px ${spotlightPosition.y + spotlightPosition.height}px,
              ${spotlightPosition.x}px ${spotlightPosition.y + spotlightPosition.height}px,
              ${spotlightPosition.x}px 100%,
              100% 100%, 100% 0%
            )`,
            }),
          transition: 'clip-path 0.3s ease-in-out',
        }}
        onClick={(e) => e.preventDefault()}
        onMouseDown={(e) => e.preventDefault()}
        onMouseUp={(e) => e.preventDefault()}
        onDoubleClick={(e) => e.preventDefault()}
        onContextMenu={(e) => e.preventDefault()}
        onWheel={(e) => e.preventDefault()}
        onTouchStart={(e) => e.preventDefault()}
        onTouchMove={(e) => e.preventDefault()}
      />

      {/* Interaction blocker when interaction is not allowed */}
      {spotlightPosition.width > 0 && spotlightPosition.height > 0 && !allowInteraction && (
        <Box
          className="tour-interaction-blocker"
          sx={{
            position: 'fixed',
            left: spotlightPosition.x,
            top: spotlightPosition.y,
            width: spotlightPosition.width,
            height: spotlightPosition.height,
            backgroundColor: 'transparent',
            zIndex: 100001,
            pointerEvents: 'auto',
            cursor: 'default',
          }}
          onClick={(e) => e.preventDefault()}
          onMouseDown={(e) => e.preventDefault()}
          onMouseUp={(e) => e.preventDefault()}
          onDoubleClick={(e) => e.preventDefault()}
          onContextMenu={(e) => e.preventDefault()}
        />
      )}

      {/* Spotlight border */}
      {spotlightPosition.width > 0 && spotlightPosition.height > 0 && (
        <Box
          className="tour-spotlight-border"
          sx={{
            position: 'fixed',
            left: spotlightPosition.x,
            top: spotlightPosition.y,
            width: spotlightPosition.width,
            height: spotlightPosition.height,
            border: '2px solid #4caf50',
            borderRadius: '4px',
            zIndex: 100000,
            pointerEvents: 'none',
            transition: 'all 0.3s ease-in-out',
            boxShadow: '0 0 10px rgba(76, 175, 80, 0.5)',
          }}
        />
      )}
    </>
  )
}

export default TourSpotlight
